//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import "@polymer/polymer/lib/elements/dom-if.js";
import {
  _webinarStatusLabel,
  _isShowPrice,
  _isStrikethroughPrice,
  _isWebinarSeries,
} from "../../../../utils/Webinar";
import { _checkSkpPoint } from "../../../../utils/skp";

import skp from "images/icons/icon_skp_point.svg";
import webinar_series from "images/icons/icon_webinar_series.svg";
import General from "../../../../utils/General";

import "./WebinarCardSearch.style";

class WebinarCardSearch extends PolymerElement {
  static get template() {
    return html`
      <style include="webinar-card-search-style"></style>
      <div class="item-webinar-container" on-click="_goToWebinarDetail">
        <div class="thumbnail-webinar">
          <img src="[[webinarItem.webinar_content.thumbnail]]" />
          <div
            class$="webinar-status-container {{_webinarStatusLabel(webinarItem)}}"
          >
            {{webinarItem.webinar_content.broadcast_status_text}}
          </div>
        </div>
        <div class="detail-webinar">
          <div class="description-webinar">
            <div class="webinar-schdule-continer">
              <dom-if if="{{_isWebinarSeries(webinarItem)}}">
                <template>
                  <div class="webinar-series-indicator">
                    <img src="[[iconWebinarSeries]]" />
                    <p>{{webinarItem.webinar_content.total_session}}</p>
                    <hr class="line-grey" />
                  </div>
                </template>
              </dom-if>
              <p class="webinar-schdule">
                {{webinarItem.webinar_content.broadcast_time}}
              </p>
            </div>
            <h2 class="webinar-title">{{webinarItem.webinar_content.title}}</h2>
            <div class="webinar-skp-price-container">
              <template is="dom-if" if="{{_checkSkpPoint(webinarItem.webinar_content.skp_point)}}">
                <div class="skp-point-container">
                  <img src="[[iconSkpPoint]]" />
                  <span class="skp-point">+{{formattedSkpPoint(webinarItem.webinar_content.skp_point)}} SKP</span>
                </div>
              </template>
              <template is="dom-if" if="{{_isShowPrice(webinarItem)}}">
                <template is="dom-if" if="{{isLogin}}">
                  <template is="dom-if" if="{{_isStrikethroughPrice(webinarItem)}}">
                    <p>Harga {{webinarItem.webinar_content.payment_info.normal_price}} <span class="strikethrough-price">{{webinarItem.webinar_content.payment_info.base_price}}</span></p>
                  </template>
                  <template is="dom-if" if="{{!_isStrikethroughPrice(webinarItem)}}">
                    <p>Harga {{webinarItem.webinar_content.payment_info.normal_price}}</p>
                  </template>
                </template>
                <template is="dom-if" if="{{!isLogin}}">
                  <p>Harga {{webinarItem.webinar_content.payment_info.base_price}}</p>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      iconSkpPoint: {
        type: String,
        value: skp,
      },
      iconWebinarSeries: {
        type: String,
        value: webinar_series,
      },
      webinarItem: {
        type: Object,
      },
      isLogin: {
        type: Number,
      },
      _webinarStatusLabel: {
        type: Function,
        value: () => _webinarStatusLabel,
      },
      _isShowPrice: {
        type: Function,
        value: () => _isShowPrice,
      },
      _isStrikethroughPrice: {
        type: Function,
        value: () => _isStrikethroughPrice,
      },
      _isWebinarSeries: {
        type: Function,
        value: () => _isWebinarSeries,
      },
      _checkSkpPoint: {
        type: Function,
        value: () => _checkSkpPoint,
      },
      formattedSkpPoint: {
        type: Function,
        value: () => General.formattedSkpPoint,
      },
    };
  }

  ready() {
    super.ready();
  }

  _handleClickShare() {
    this.modalShare = true;
  }

  _goToWebinarDetail() {
    const typeWebinar = this.webinarItem.webinar_content.type;
    window.location = `/webinar/${this.webinarItem.slug}?type=${typeWebinar}`;
  }
}
customElements.define("webinar-card-search", WebinarCardSearch);
